export default ["https://www.snapchat.com", "https://bolt-gcdn.sc-cdn.net"];
